import { render, staticRenderFns } from "./OctMacula.vue?vue&type=template&id=47098604&scoped=true"
import script from "./OctMacula.vue?vue&type=script&lang=js"
export * from "./OctMacula.vue?vue&type=script&lang=js"
import style0 from "./OctMacula.vue?vue&type=style&index=0&id=47098604&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47098604",
  null
  
)

export default component.exports